module.exports = __webpack_public_path__ + "img/2.950fd324.jpg";